/*
 * File: elmoApi.ts
 * Project: rosita
 * -----
 * Last Modified: 24 Feb 2022 11:31:37 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ApiMultipleResponse } from 'models/ApiModels';
import { DeploymentRequest } from 'models/DeploymentRequest';
import { ReduxState } from 'redux/store';

/* ******************** Base Query ******************** */
const baseUrl = process.env.REACT_APP_ELMO_BASE_URL;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_ELMO;

export const elmoApi = createApi({
  reducerPath: 'elmoApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as ReduxState).app.accessToken;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('x-functions-key', functionsKey);
        headers.set('Content-Type', 'application/json');
      }

      return headers;
    }
  }),
  tagTypes: ['DeploymentRequests', 'ChartData'],
  endpoints: (builder) => ({
    getDeploymentRequests: builder.query<ApiMultipleResponse<DeploymentRequest>, string>({
      providesTags: ['DeploymentRequests'],
      query: (divisionId) => ({
        url: `/divisions/${divisionId}/deploymentRequests?orderByDirection=descending`
      })
    }),
    getVersion: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/version',
        method: 'GET',
        responseHandler: (response): Promise<string> => response.text()
      })
    }),
    getApiName: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/apiName',
        method: 'GET',
        responseHandler: (response): Promise<string> => response.text()
      })
    })
  })
});

export const { useGetDeploymentRequestsQuery, useGetVersionQuery, useGetApiNameQuery } = elmoApi;
